import React, { useEffect } from "react";
import Card from "react-bootstrap/Card";

import Button from "react-bootstrap/Button";
import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

import pdf from "../../Assets/Flyer.pdf";
import {  pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import useInViewOnce from "../../hooks/useInViewOnce";
import { useTranslation } from "react-i18next";

// Set up PDF.js worker from CDN
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function SupportCard() {
  const { t } = useTranslation();

  const { ref: cardRef, hasEntered: cardSeen } = useInViewOnce({ threshold: 0.18, once: true });

   const location = useLocation();// Initialize location
  //  const navigate = useNavigate(); // Initialize navigate
  
    const handleClick = () => {
    window.open("https://www.favrhood.com/"); // This will navigate to the "/another-page" route
    };
    const handleClick_1 = () => {
      window.open("https://docs.google.com/forms/d/1EPH7BwasKW3g_4OGmO171Wuho5EvoNznMCkFEA7q5Ok/viewform"); // This will navigate to the "/another-page" route
    };
    const handleClick_2 = () => {
      window.open("https://docs.google.com/forms/d/1Q2Lc15IwomBIFeSAxIfsK56xI3vkCjvKW8yXQcWQvmM/viewform"); // This will navigate to the "/another-page" route
    };
    const handleClick_3 = () => {
     window.open("https://docs.google.com/forms/d/1iwEzu53wDAe41RjEDe-gHIX9H61QikSfR2RKmyCBp_M/viewform"); // This will navigate to the "/another-page" route
    };
    // const handleClick_4 = () => {
    //   navigate("/share"); // This will navigate to the "/another-page" route
    // };

   useEffect(() => {
      if (location.hash) {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, [location]);
  
  return (
    <Card
      ref={cardRef}
      className={`quote-card-view cf-card-anim cf-reveal${cardSeen ? " is-seen" : ""}`}
    >
      <Card.Body>
        <section className="support-card-section">
          <h2 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            {t("support.card.intro.titlePrefix")}
            <strong className="purple"> {t("support.card.intro.titleEmphasis")}</strong> {t("support.card.intro.titleSuffix")}
          </h2>
          <p className="about-text">{t("support.card.intro.p1")}</p>
        </section>

        <section className="support-card-section" style={{ marginTop: "2rem" }}>
          <h2 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            {t("support.card.favrhood.titlePrefix")} <strong className="purple">{t("support.card.favrhood.titleEmphasis")}</strong> {t("support.card.favrhood.titleSuffix")}
          </h2>
          <p className="about-text">{t("support.card.favrhood.lead")}</p>
          <ul className="about-text" style={{ marginTop: "0.75rem" }}>
            {(Array.isArray(t("support.card.favrhood.helps", { returnObjects: true }))
              ? t("support.card.favrhood.helps", { returnObjects: true })
              : []
            ).map((item, index) => (
              <li key={`${index}-${item}`}>{item}</li>
            ))}
          </ul>
          <p className="about-text" style={{ marginTop: "0.75rem" }}>
            {t("support.card.favrhood.p2")}
          </p>
        </section>

        <section className="support-card-section" style={{ marginTop: "2rem" }}>
          <h2 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            {t("support.card.changes.titlePrefix")} <strong className="purple">{t("support.card.changes.titleEmphasis")}</strong> {t("support.card.changes.titleSuffix")}
          </h2>

          <h3 className="purple" style={{ fontSize: "1.1em" }}>
            {t("support.card.changes.connect.title")}
          </h3>
          <p className="about-text">{t("support.card.changes.connect.text")}</p>

          <h3 className="purple" style={{ fontSize: "1.1em", marginTop: "1rem" }}>
            {t("support.card.changes.create.title")}
          </h3>
          <p className="about-text">{t("support.card.changes.create.text")}</p>

          <h3 className="purple" style={{ fontSize: "1.1em", marginTop: "1rem" }}>
            {t("support.card.changes.scale.title")}
          </h3>
          <p className="about-text">{t("support.card.changes.scale.text")}</p>
        </section>

        <section className="support-card-section" style={{ marginTop: "2rem" }}>
          <h2 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            {t("support.card.whySupport.titlePrefix")} <strong className="purple">{t("support.card.whySupport.titleEmphasis")}</strong> {t("support.card.whySupport.titleSuffix")}
          </h2>
          <p className="about-text">{t("support.card.whySupport.lead")}</p>
          <p className="about-text">{t("support.card.whySupport.lead2")}</p>
          <ul className="about-text" style={{ marginTop: "0.75rem" }}>
            {(Array.isArray(t("support.card.whySupport.items", { returnObjects: true }))
              ? t("support.card.whySupport.items", { returnObjects: true })
              : []
            ).map((item) => (
              <li key={item.label}>
                <strong className="purple">{item.label}</strong> — {item.text}
              </li>
            ))}
          </ul>
        </section>

        <section className="support-card-section" style={{ marginTop: "2rem" }}>
          <h2 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            {t("support.card.ways.titlePrefix")} <strong className="purple">{t("support.card.ways.titleEmphasis")}</strong> {t("support.card.ways.titleSuffix")}
          </h2>
          <p className="about-text">{t("support.card.ways.lead")}</p>

          <ol className="about-text" style={{ marginTop: "0.75rem" }}>
            <li style={{ marginBottom: "0.75rem" }}>
              <strong className="purple">{t("support.card.ways.items.joinFavrhood.label")}</strong> {t("support.card.ways.items.joinFavrhood.text")}
              <div>
                <Button onClick={handleClick}>{t("support.card.ways.items.joinFavrhood.button")}</Button>
              </div>
            </li>
            <li style={{ marginBottom: "0.75rem" }}>
              <strong className="purple">{t("support.card.ways.items.sponsor.label")}</strong> {t("support.card.ways.items.sponsor.text")}
              <div>
                <Button onClick={handleClick_1}>{t("support.card.ways.items.sponsor.button")}</Button>
              </div>
            </li>
            <li style={{ marginBottom: "0.75rem" }}>
              <strong className="purple">{t("support.card.ways.items.volunteer.label")}</strong> {t("support.card.ways.items.volunteer.text")}
              <div>
                <Button onClick={handleClick_2}>{t("support.card.ways.items.volunteer.button")}</Button>
              </div>
            </li>
            <li style={{ marginBottom: "0.75rem" }}>
              <strong className="purple">{t("support.card.ways.items.partner.label")}</strong> {t("support.card.ways.items.partner.text")}
              <div>
                <Button onClick={handleClick_3}>{t("support.card.ways.items.partner.button")}</Button>
              </div>
            </li>
            <li>
              <strong className="purple">{t("support.card.ways.items.spread.label")}</strong> {t("support.card.ways.items.spread.text")}
              <div>
                <Button href={pdf} target="_blank">
                  {t("support.card.ways.items.spread.button")}
                </Button>
              </div>
            </li>
          </ol>
        </section>
      </Card.Body>
    </Card>
  );
}

export default SupportCard;
